/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileDto
 */
export interface ProfileDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    oscalVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    documentId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProfileDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProfileDto
     */
    updated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    hasImports?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileDto
     */
    importCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    hasModifies?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileDto
     */
    modifyCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    hasMerges?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileDto
     */
    mergeCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    hasIncludeControls?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileDto
     */
    includeControlsCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileDto
     */
    hasExcludeControls?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileDto
     */
    excludeControlsCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    metadataTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileDto
     */
    metadataVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProfileDto
     */
    metadataPublished?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProfileDto
     */
    metadataLastModified?: Date;
}

/**
 * Check if a given object implements the ProfileDto interface.
 */
export function instanceOfProfileDto(value: object): value is ProfileDto {
    return true;
}

export function ProfileDtoFromJSON(json: any): ProfileDto {
    return ProfileDtoFromJSONTyped(json, false);
}

export function ProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'version': json['version'] == null ? undefined : json['version'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'hasImports': json['hasImports'] == null ? undefined : json['hasImports'],
        'importCount': json['importCount'] == null ? undefined : json['importCount'],
        'hasModifies': json['hasModifies'] == null ? undefined : json['hasModifies'],
        'modifyCount': json['modifyCount'] == null ? undefined : json['modifyCount'],
        'hasMerges': json['hasMerges'] == null ? undefined : json['hasMerges'],
        'mergeCount': json['mergeCount'] == null ? undefined : json['mergeCount'],
        'hasIncludeControls': json['hasIncludeControls'] == null ? undefined : json['hasIncludeControls'],
        'includeControlsCount': json['includeControlsCount'] == null ? undefined : json['includeControlsCount'],
        'hasExcludeControls': json['hasExcludeControls'] == null ? undefined : json['hasExcludeControls'],
        'excludeControlsCount': json['excludeControlsCount'] == null ? undefined : json['excludeControlsCount'],
        'metadataTitle': json['metadataTitle'] == null ? undefined : json['metadataTitle'],
        'metadataVersion': json['metadataVersion'] == null ? undefined : json['metadataVersion'],
        'metadataPublished': json['metadataPublished'] == null ? undefined : (new Date(json['metadataPublished'])),
        'metadataLastModified': json['metadataLastModified'] == null ? undefined : (new Date(json['metadataLastModified'])),
    };
}

export function ProfileDtoToJSON(json: any): ProfileDto {
    return ProfileDtoToJSONTyped(json, false);
}

export function ProfileDtoToJSONTyped(value?: ProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'version': value['version'],
        'oscalVersion': value['oscalVersion'],
        'documentId': value['documentId'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'hasImports': value['hasImports'],
        'importCount': value['importCount'],
        'hasModifies': value['hasModifies'],
        'modifyCount': value['modifyCount'],
        'hasMerges': value['hasMerges'],
        'mergeCount': value['mergeCount'],
        'hasIncludeControls': value['hasIncludeControls'],
        'includeControlsCount': value['includeControlsCount'],
        'hasExcludeControls': value['hasExcludeControls'],
        'excludeControlsCount': value['excludeControlsCount'],
        'metadataTitle': value['metadataTitle'],
        'metadataVersion': value['metadataVersion'],
        'metadataPublished': value['metadataPublished'] == null ? undefined : ((value['metadataPublished']).toISOString()),
        'metadataLastModified': value['metadataLastModified'] == null ? undefined : ((value['metadataLastModified']).toISOString()),
    };
}

